import InterviewServiceAbstract from './InterviewServiceAbstract'
import InterviewService from './InterviewService'

export default new InterviewService() as InterviewServiceAbstract
